import { useState, useEffect } from 'react';
import { useApp } from '@/contexts/AppContext';
import type { WootricUser } from '@/types/wootric';

interface UseUserProfileResult {
  user: WootricUser | null;
  isLoading: boolean;
  error: Error | null;
}

export function useUserProfile(): UseUserProfileResult {
  const { currentUser } = useApp();
  const [user, setUser] = useState<WootricUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setIsLoading(true);

        if (!currentUser) {
          setIsLoading(false);
          return;
        }

        const email = `${currentUser.name.toLowerCase().replace(/\s+/g, '.').replace(/'/g, '')}@example.com`;
        const userId = currentUser.id;
        const role = currentUser.forecasterRole;

        setUser({
          email,
          userId,
          role,
          createdAt: new Date(),
        });
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to get user profile'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserProfile();
  }, [currentUser]);

  return { user, isLoading, error };
}
